/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

export const COMPARE_TABLE_PRODUCT_HEADER_NAME = 'product';
export const COMPARE_TABLE_ADD_PRODUCT_HEADER_NAME = 'addProduct';
export const COMPARE_TABLE_ATTRIBUTE_HEADER_NAME = '__attr';
export const COMPARE_PRODUCTS_STATE_KEY = 'compareProducts';
export const HEADERS = [
	COMPARE_TABLE_PRODUCT_HEADER_NAME,
	COMPARE_TABLE_ATTRIBUTE_HEADER_NAME,
	COMPARE_TABLE_ADD_PRODUCT_HEADER_NAME,
] as const;
